// Auto-generated: iOS apple-touch-startup-image links.
// Each entry maps a device's physical resolution + pixel ratio to a splash PNG.

type Device = { w: number; h: number; r: number };

const DEVICES: Device[] = [
  { w: 1290, h: 2796, r: 3 },
  { w: 1179, h: 2556, r: 3 },
  { w: 1284, h: 2778, r: 3 },
  { w: 1170, h: 2532, r: 3 },
  { w: 1080, h: 2340, r: 3 },
  { w: 1242, h: 2688, r: 3 },
  { w: 828, h: 1792, r: 2 },
  { w: 1125, h: 2436, r: 3 },
  { w: 1242, h: 2208, r: 3 },
  { w: 750, h: 1334, r: 2 },
  { w: 2048, h: 2732, r: 2 },
  { w: 1668, h: 2388, r: 2 },
  { w: 1640, h: 2360, r: 2 },
  { w: 1620, h: 2160, r: 2 },
  { w: 1536, h: 2048, r: 2 },
];

export const appleSplashLinks = DEVICES.flatMap(({ w, h, r }) => {
  const cssW = w / r;
  const cssH = h / r;
  return [
    {
      rel: "apple-touch-startup-image",
      href: `/splash/apple-splash-${w}-${h}.png`,
      media: `(device-width: ${cssW}px) and (device-height: ${cssH}px) and (-webkit-device-pixel-ratio: ${r}) and (orientation: portrait)`,
    },
    {
      rel: "apple-touch-startup-image",
      href: `/splash/apple-splash-${h}-${w}.png`,
      media: `(device-width: ${cssW}px) and (device-height: ${cssH}px) and (-webkit-device-pixel-ratio: ${r}) and (orientation: landscape)`,
    },
  ];
});
